// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","407":"95b64a6e","453":"d7eeaac4","673":"98ea7ec2"}[chunkId] || chunkId) + "-" + {"245":"1c341810127f6c71716e","407":"88fdcaa8fffab0215636","453":"4f7221392afcecf65930","522":"88b202ad2c0c3d8bdff4","673":"07bc6e03675e16546de1"}[chunkId] + ".js";
};